import { AgFloatingFilterComponent } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { FilterChangedEvent, IFloatingFilterParams } from 'ag-grid-community';
import { Observable, of } from 'rxjs';
// noinspection ES6PreferShortImport
import { EnumTransformService } from '../../services/enum-transform.service';


@Component({
  selector: 'pt-enum-adverb-filter-component',
  template: `
    <div class="ag-floating-filter-body" role="presentation">
      <div class="ag-floating-filter-input" role="presentation">
        <div role="presentation" class="ag-labeled ag-label-align-left ag-text-field ag-input-field ag-disabled" disabled>
          <div class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation" (click)="onInputClick()">
            <input
              style="cursor: pointer!important"
              type="text" disabled
              class="ag-input-field-input ag-text-field-input text-ellipsis"
              [ngModel]="(this.currentValue | async) + counterFilter"
            >
          </div>
        </div>
      </div>
    </div>
  `
})
export class EnumToAdverbFilterComponent implements AgFloatingFilterComponent {

  params: IFloatingFilterParams;
  currentValue: Observable<string>;
  countFilterValues: number;

  constructor(private enumTransformService: EnumTransformService) {
  }

  get counterFilter() {
    return this.countFilterValues ? ` +${this.countFilterValues}` : '';
  }

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
    this.currentValue = of('');
    this.countFilterValues = null;
  }

  onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent | null): void {
    if (parentModel?.values && parentModel?.values?.length > 0) {
      this.currentValue = this.enumTransformService.toAdverb(parentModel.values[0]);
      if (parentModel.values.length > 1) {
        this.countFilterValues = parentModel.values.length - 1;
      } else {
        this.countFilterValues = null;
      }
    } else {
      this.currentValue = of('');
      this.countFilterValues = null;
    }
  }

  onInputClick() {
    this.params.showParentFilter();
  }
}
